import React, { useState } from "react";
import { formatPrice } from "utils/helpers";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { SVGs } from "utils/svgs";
import BlankLink from "components/shared/BlankLink";

export default function WatchUltra4Section({
  theme,
  product,
  isPrePage,
  preLink,
  colorText,
  conDetail,
  setProductConfigs,
  setOpenModal,
  onClickRegister
}) {
  const { titleSvg, semiTitle, _data } = product;

  const [showAll, setShowAll] = useState(false);
  const displayedData = showAll ? _data : _data.slice(0, 4);

  return (
    <div className="container watch-container watch_ultra_2 productbundle-details">
      <div className="content-wrapper" style={{ zIndex: 2 }}>
        <h2
          className=""
          style={{ fontSize: "40px", color: `${colorText}`, fontWeight: 700 }}
        >
          <img
            className="icon-apple fw"
            src={
              colorText === "black"
                ? "../hm_service_image/icon_apple2.png"
                : "../hm_service_image/icon_apple.png"
            }
            alt="setting"
          />
          {titleSvg}
        </h2>
        <div
          className="title"
          style={{ fontSize: "20px", color: `${colorText}`, fontWeight: 700 }}
        >
          {semiTitle}
        </div>

        {/* Chi tiết sản phẩm */}
        <div className="popup-info">
          <img src={SVGs.settting} alt="setting" />
          <a
            className="btn-popup"
            onClick={() => {
              setProductConfigs(conDetail);
              setOpenModal(true);
            }}
            target="_blank"
          >
            Chi tiết sản phẩm
          </a>
        </div>

        <div className="text-scroll-watch">
          Giảm thêm 500K khi mua kèm iPhone 18 series
        </div>

        <div className="item-grid">
          {displayedData?.map((val, index) => {
            return (
              <div className="item-box" key={index}>
                <div className="image-wrapper">
                  <img src={val?.imageUrl} alt="" width="100%" />
                </div>

                <h2 className="product-title">{val?.productName}</h2>

                <div className="price price-watch" style={{ transition: "all 1s ease" }}>
                  {val?.price ? (
                    <span>{formatPrice(val?.price)}đ</span>
                  ) : (
                    <span className="no-product-message">
                      Sản phẩm không tồn tại
                    </span>
                  )}
                </div>

                <div>
                  {/* <BlankLink
                    className="btn_deposit"
                    data-popup-id="popup-registration"
                    onClick={() => onClickRegister(prodSelected?.productId)}
                  >
                    Đăng ký nhận tin
                  </BlankLink> */}
                  <BlankLink
                    className="btn_deposit"
                    data-popup-id="popup-registration"
                    onClick={() => window.open(`https://shopdunk.com${val?.path_office}`, "_blank")}
                  >
                    Mua ngay
                  </BlankLink>
                  {/* {isPrePage && val?.productId ? (
                    <Link
                      className="btn_deposit"
                      to={{
                        pathname: preLink,
                        state: { productId: val.productId, isDeposit: true },
                      }}
                    >
                      Đặt cọc ngay
                    </Link>
                  ) : (
                    <BlankLink
                      className="btn_deposit"
                      data-popup-id="popup-registration"
                      onClick={() => onClickRegister(val.productId)}
                    >
                      Đăng ký nhận tin
                    </BlankLink>
                  )} */}
                </div>
              </div>
            );
          })}
        </div>

        {_data.length > 4 && (
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <button
              onClick={() => setShowAll(!showAll)}
              style={{
                padding: "10px 20px",
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              {showAll ? "Thu gọn" : "Xem thêm"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
